<div class="tw-size-14 tw-rounded-2xl main-background-color d-flex justify-content-center align-items-center">
  <img class="tw-size-6" src="{{ image }}" alt="" />
</div>
